import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { AssetInfo as OldAssetInfo } from "@models/tradable/split/asset_info";

export interface AssetInfo {
	readonly id: number; // TODO unused?
	readonly description: string;
	readonly info: string;
	readonly infoIntegration: string;
	readonly extraInfo: string;
}

export class AssetInfoAdapter extends BaseAdapter<OldAssetInfo, AssetInfo> {
	public adapt(item: OldAssetInfo): AssetInfo {
		if (!item) {
			return null;
		}

		return {
			id: Number(item.getId()),
			description: item.getDescription() ?? "",
			info: item.getInfo() ?? "",
			infoIntegration: item.getInfoIntegration() ?? "",
			extraInfo: item.getExtraInfo() ?? ""
		};
	}
}
